import { useAuthContext } from '../auth/useAuthContext';

const useSession = () => {
  const { session } = useAuthContext();
  console.log('🔌 [useSession] Hook called, session:', !!session);
  return session;
};

export default useSession;